import React from "react";
import { Toolbar, ToolbarGroup } from "../Toolbar";
import { Button, ButtonGroup, InputGroup } from "@blueprintjs/core";
import { Icon } from "../../atoms/Icon";
import { FilterToolbar } from "../FilterToolbar";

function OpportunityListPageHeader({ filters, setFilters, filterOptions, onAddOpportunityPress }) {
  return (
    <Toolbar title="Active Opportunities">
      <FilterToolbar
        value={filters}
        onChange={setFilters}
        filterOptions={filterOptions}
      />

      <ToolbarGroup>
        <ButtonGroup>
          <Button
            icon="plus"
            className="narrow bold"
            text="Add Opportunity"
            onClick={onAddOpportunityPress}
          />
        </ButtonGroup>
      </ToolbarGroup>
    </Toolbar>
  );
}

export default OpportunityListPageHeader;
